import { FunctionComponent, useState, useRef, useEffect, useCallback } from "react";
import styles from "./Import.module.css";
import { CSVLink } from "react-csv";
import classNames from "classnames";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import "../../theme-vars.css";

type props = {
  onClick?: () => void;
  setExpandImport: (data: boolean) => void;
  onExport?: () => any;
  onCallLogsImport?: () => any;
  onNotesImport?: () => any;
  onTasksImport?: () => any;
  title?: any;
  expand: boolean;
  close: () => void;
  user: any;
  role: any;
  theme: any;
};

const Import: FunctionComponent<props> = ({
  onClick,
  setExpandImport,
  onExport,
  onNotesImport,
  onCallLogsImport,
  onTasksImport,
  title,
  expand,
  close,
  role,
  user,
  theme,
}) => {
  const csvLink: any = useRef();
  const modalRef = useRef(null);
  const filterClass = classNames(styles.parent, { [styles.showAnim]: expand === true });

  /** Fields returned from onExport() */
  const [feilds, setFields] = useState([]);
  const dispatcher = useDispatch();

  /** ------------ Load Export Data on Mount ------------ */
  useEffect(() => {
    setFields(onExport && onExport());
    // eslint-disable-next-line
  }, []);

  /** ------------ Close popup when clicking outside ------------ */
  const handleClickOutside = useCallback((event: any) => {
    const element: any = modalRef.current;
    if (element && !element.contains(event.target)) {
      close();
    }
    // eslint-disable-next-line
  }, []);

  /** Attach/Detach outside click listener */
  useEffect(() => {
    if (expand === true) {
      setTimeout(
        () => document.addEventListener("click", handleClickOutside),
        100
      );
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    // Cleanup when popup closes
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [expand]);

  /** ------------ Conditional theme styling ------------ */
  const cardContainerStyles = { backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <div
      className={filterClass}
      ref={modalRef}
      style={user.import !== true ? { height: "80px", ...cardContainerStyles } : cardContainerStyles}
    >

      {/* ------------------ EXPORT SECTION ------------------ */}
        <>
          <div>
            <div
              onClick={() => {
                if (feilds.length !== 0) {
                  csvLink.current.link.click();
                } else {
                  dispatcher(
                    showSnackbarAction(
                      "Please Select The Records To Export",
                      "error"
                    )
                  );
                }
              }}
            >
              <p style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}
                className={styles.importText}
              >Export</p>
              <CSVLink
                data={feilds}
                filename={"data.csv"}
                className={styles.importText}
                ref={csvLink}
                target="_blank"
              />
            </div>
          </div>
        </> 

      {/* ------------------ IMPORT BUTTON ------------------ */}
      {title !== "Drill Down" && (
        <p
          className={styles.importText}
          onClick={() => {
            if (!(title === "Add Call Logs" || title === "Add Task")) {
              onClick && onClick();
              setExpandImport(false);
            }
          }}
          style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
            pointerEvents: (title === "Add Call Logs" || title === "Add Task") ? "none" : "auto",
            opacity: (title === "Add Call Logs" || title === "Add Task") ? 0.5 : 1
          }}
        >
          {role === "Lead Manager" || role === "Team Lead"
            ? "Import"
            : "Import"}
        </p>
      )}

      {/* ------------------ IMPORT OPTIONS ------------------ */}
      {user.import === true && (
        <>
          {onCallLogsImport && (
            <>
              <p
                style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}
                className={styles.importText}
                onClick={() => {
                  setExpandImport(false);
                  onCallLogsImport && onCallLogsImport();
                }}
              >
                Import Call Logs
              </p>
            </>
          )}

          {onNotesImport && (
            <>
              <p
                style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}
                className={styles.importText}
                onClick={() => {
                  onNotesImport && onNotesImport();
                  setExpandImport(false);
                }}
              >
                Import Notes
              </p>
            </>
          )}

          {onTasksImport && (
            <>
              <p
                style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}
                className={styles.importText}
                onClick={() => {
                  onTasksImport && onTasksImport();
                  setExpandImport(false);
                }}
              >
                Import Tasks
              </p>
            </>
          )}
        </>
      )}
    </div>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(Import);
